module.exports = __webpack_public_path__ + "img/zip-icon.a4b58858.svg";